// VERSION 1.0.0
// AUTHOR AGALYA
// LastEdit : SATHISH
// LastAdd : CODE REVIEW CORRECTION AND PAGE WISE CHECK
// MODFIED DATE:06-11-2025

const RuleEngineActionTypes = {
	/** ***************** GET RULE ENGINE LIST START *********************** */
	GET_RULE_ENGINE_LIST_START: 'get_rule_engine_list_start',
	GET_RULE_ENGINE_LIST_SUCCESS: 'get_rule_engine_list_success',
	GET_RULE_ENGINE_LIST_FAILURE: 'get_rule_engine_list_failure',
	GET_RULE_ENGINE_LIST_RESET: 'get_rule_engine_list_reset',
	GET_RULE_ENGINE_LIST_CHANGED: 'get_rule_engine_list_changed',
	/** ***************** GET RULE ENGINE LIST END *********************** */

	/** ***************** ADD RULE ENGINE LIST START *********************** */
	ADD_RULE_ENGINE_LIST_START: 'add_rule_engine_list_start',
	ADD_RULE_ENGINE_LIST_SUCCESS: 'add_rule_engine_list_success',
	ADD_RULE_ENGINE_LIST_FAILURE: 'add_rule_engine_list_failure',
	ADD_RULE_ENGINE_LIST_RESET: 'add_rule_engine_list_reset',
	ADD_RULE_ENGINE_LIST_CHANGED: 'add_rule_engine_list_changed',
	/** ***************** ADD RULE ENGINE LIST END *********************** */

	/** ***************** DELETE RULE ENGINE LIST START *********************** */
	DELETE_RULE_ENGINE_LIST_START: 'delete_rule_engine_list_start',
	DELETE_RULE_ENGINE_LIST_SUCCESS: 'delete_rule_engine_list_success',
	DELETE_RULE_ENGINE_LIST_FAILURE: 'delete_rule_engine_list_failure',
	DELETE_RULE_ENGINE_LIST_RESET: 'delete_rule_engine_list_reset',
	DELETE_RULE_ENGINE_LIST_CHANGED: 'delete_rule_engine_list_changed',
	/** ***************** DELETE RULE ENGINE LIST END *********************** */
};
export default RuleEngineActionTypes;
